import React from 'react';
import { useReportUi } from './useReportUi';

/**
 * KPI tile used across analytics report pages (Κλασικό / Νέο aware).
 */
const ReportMetricCard = ({ label, value, unit, semantic = 'info', sub, className }) => {
  const { theme, dash, cn } = useReportUi();

  return (
    <div className={cn(dash.metricCard(), 'p-6', className)}>
      <p className={cn('text-sm font-medium mb-1', theme.text.secondary)}>{label}</p>
      <div className="flex items-baseline gap-2">
        <span className={cn('text-3xl font-bold', theme.text.primary)}>{value}</span>
        {unit ? <span className={cn('text-lg', theme.text.secondary)}>{unit}</span> : null}
      </div>
      {sub ? <p className={cn('text-xs mt-1', theme.text.muted)}>{sub}</p> : null}
    </div>
  );
};

export default ReportMetricCard;
